import * as Scrivito from "scrivito";
import {
  defaultFormInputEditingAttributes,
  defaultFormInputEditingProperties,
  defaultFormInputInitialContent,
} from "../../_defaultFormEditingConfig";
import RadioButton from "../RadioButtonWidget/RadioButtonWidgetClass";

Scrivito.provideEditingConfig("RadioboxWidget", {
  title: "Radiobox",
  attributes: {
    ...defaultFormInputEditingAttributes,
  },
  properties: [...defaultFormInputEditingProperties, "radioButtons"],
  initialContent: {
    ...defaultFormInputInitialContent,
    radioButtons: [
      new RadioButton({ text: "Option 1" }),
      new RadioButton({ text: "Option 2" }),
    ],
  },
  validations: [
    [
      "csvColumnName",
      (csvColumnName) => {
        if (!csvColumnName) {
          return "CSV column name is required";
        }
        return null;
      },
    ],
  ],
});
